import {
    SHOP_VERTICAL_TEMPLATE_DESCRIPTORS,
    type ShopVerticalTemplateDescriptor,
} from "../shopVerticalCatalog";
import type { SiteTemplateDefinition } from "../types";
import { lagunaTemplate, renderLagunaStorefront } from "./laguna";
import { createShopTemplatePageTypes } from "./shopTemplateManifest";

/**
 * Gives each system template a stable registry identity while keeping one
 * storefront implementation. Snapshot design and authored blocks provide the
 * visual differences; commerce behaviour remains in the Laguna runtime.
 */
export function createSharedLagunaShopTemplate(
    descriptor: ShopVerticalTemplateDescriptor,
): SiteTemplateDefinition {
    const editable = lagunaTemplate.manifest.editable;

    return {
        manifest: {
            ...lagunaTemplate.manifest,
            code: descriptor.code,
            category: descriptor.category,
            name: descriptor.name,
            description: descriptor.description,
            previewImage: descriptor.previewImage,
            defaults: {
                colors: { ...descriptor.defaults.colors },
                typography: { ...descriptor.defaults.typography },
                layout: { ...descriptor.defaults.layout },
                components: { ...descriptor.defaults.components },
            },
            pageTypes: createShopTemplatePageTypes(),
            editable: {
                ...editable,
                header: [...editable.header],
                footer: [...editable.footer],
                buttons: [...editable.buttons],
            },
        },
        render: (props) => renderLagunaStorefront(
            props,
            descriptor.defaults,
            descriptor.presentationProfile ?? descriptor.inspiration,
        ),
    };
}

export const sharedLagunaShopTemplates: SiteTemplateDefinition[] =
    SHOP_VERTICAL_TEMPLATE_DESCRIPTORS.map(createSharedLagunaShopTemplate);
